import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@repo/ui/components/ui/alert-dialog";
import { Button } from "@repo/ui/components/ui/button";
import { cn } from "@repo/ui/lib/utils";
import { Trash2Icon } from "lucide-react";
import { useState } from "react";
import { useAgentChatContext } from "./context";

export function AgentChatDeleteButton({ className }: { className?: string }) {
  const { state, actions } = useAgentChatContext();
  const [open, setOpen] = useState(false);

  const previewTitle = state.messages.find((m) => m.role === "user")?.text?.slice(0, 60);
  const disabled = !state.hasActiveThread;

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        className={cn("h-7 w-7 text-muted-foreground", className)}
        title="Delete chat"
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        <Trash2Icon className="h-4 w-4" />
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete this chat?</AlertDialogTitle>
            <AlertDialogDescription>
              {previewTitle ? (
                <>"{previewTitle}" will be permanently removed.</>
              ) : (
                "This conversation will be permanently removed."
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                actions.deleteChat();
                setOpen(false);
              }}
            >
              Delete
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
